import { generatePath as routerGenPath } from "react-router-dom";

import type { IExtractParams } from "./types";

export function generatePath<T extends string>(
  path: T,
  params?: IExtractParams<T>,
  search?: string | string[][] | Record<string, string> | URLSearchParams,
) {
  return generate(path, params, search);
}

export function generateApiPath<T extends string>(
  path: T,
  params?: IExtractParams<T>,
  search?: string | string[][] | Record<string, string> | URLSearchParams,
) {
  return generate(path, params, search, true);
}

function generate<T>(
  path: T,
  params?: IExtractParams<T>,
  search?: string | string[][] | Record<string, string> | URLSearchParams,
  isApi?: boolean,
) {
  const searchParams = search
    ? `?${new URLSearchParams(search).toString()}`
    : "";
  const _params = params || {};

  let url = routerGenPath(`${path}`, _params);

  if (isApi && !url.endsWith("/")) {
    url += "/";
  }

  url += searchParams;

  return url;
}
